
interface FixLogoProps {
  className?: string
  size?: number
}

export function FixLogo({ className = '', size = 20 }: FixLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M9 1L3 9H7L9 6Z" fill="#e8a820" />
      <path d="M7 9L5 15L13 7H9Z" fill="#dc2626" />
    </svg>
  )
}
